export var InputCssClass;
(function (InputCssClass) {
    InputCssClass["Base"] = "iress-input";
    InputCssClass["NativeInput"] = "iress-input__native-input";
    InputCssClass["TextArea"] = "iress-input--textarea";
    InputCssClass["Label"] = "iress-input__label";
    InputCssClass["Watermark"] = "iress-input--watermark";
    InputCssClass["Clearable"] = "iress-input--clearable";
    InputCssClass["Clear"] = "iress-input__clear";
    InputCssClass["Width2"] = "iress-input--width-2";
    InputCssClass["Width4"] = "iress-input--width-4";
    InputCssClass["Width6"] = "iress-input--width-6";
    InputCssClass["Width8"] = "iress-input--width-8";
    InputCssClass["Width10"] = "iress-input--width-10";
    InputCssClass["Width12"] = "iress-input--width-12";
    InputCssClass["Width16"] = "iress-input--width-16";
    InputCssClass["Width25Perc"] = "iress-input--width-25-perc";
    InputCssClass["Width50Perc"] = "iress-input--width-50-perc";
    InputCssClass["Width75Perc"] = "iress-input--width-75-perc";
    InputCssClass["Focus"] = "iress-input--focus";
    InputCssClass["HiddenLabel"] = "iress-input--hiddenlabel";
    InputCssClass["Error"] = "iress-input--error";
    InputCssClass["Prepend"] = "iress-input--addon-prepend";
    InputCssClass["Append"] = "iress-input--addon-append";
    InputCssClass["InputWrapper"] = "iress-input__wrapper";
    InputCssClass["AddOn"] = "iress-input__addon";
    InputCssClass["IgnoreStack"] = "iress-stack--ignore";
})(InputCssClass || (InputCssClass = {}));
export var InputSlots;
(function (InputSlots) {
    InputSlots["Prepend"] = "prepend";
    InputSlots["Append"] = "append";
})(InputSlots || (InputSlots = {}));
export var InputMode;
(function (InputMode) {
    InputMode["None"] = "none";
    InputMode["Text"] = "text";
    InputMode["Tel"] = "tel";
    InputMode["Url"] = "url";
    InputMode["Email"] = "email";
    InputMode["Numeric"] = "numeric";
    InputMode["Decimal"] = "decimal";
    InputMode["Search"] = "search";
})(InputMode || (InputMode = {}));
export var InputWidth;
(function (InputWidth) {
    InputWidth["Two"] = "2";
    InputWidth["Four"] = "4";
    InputWidth["Six"] = "6";
    InputWidth["Eight"] = "8";
    InputWidth["Ten"] = "10";
    InputWidth["Twelve"] = "12";
    InputWidth["Sixteen"] = "16";
    InputWidth["TwentyFivePercent"] = "25Perc";
    InputWidth["FiftyPercent"] = "50Perc";
    InputWidth["SeventyFivePercent"] = "75Perc";
})(InputWidth || (InputWidth = {}));
export var InputVRTState;
(function (InputVRTState) {
    InputVRTState["Focus"] = "focus";
})(InputVRTState || (InputVRTState = {}));
//# sourceMappingURL=input.types.js.map